import { getEnv } from "@/util/env.ts";

const {
    PUBLIC_ASSETS_HOST,
    PUBLIC_B2C_ASSETS_HOST,
} = getEnv();

const BASE_URL_WITH_SLASH = PUBLIC_ASSETS_HOST.endsWith('/') ? PUBLIC_ASSETS_HOST : `${PUBLIC_ASSETS_HOST}/`;
const BASE_SSR_URL_WITH_SLASH = PUBLIC_B2C_ASSETS_HOST.endsWith('/') ? PUBLIC_B2C_ASSETS_HOST : `${PUBLIC_B2C_ASSETS_HOST}/`;

export const createAssetUrl = (path: string) => {
    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;

    if (path.includes('favicon')) {
        return `${BASE_SSR_URL_WITH_SLASH}${window.location.host}/${normalizedPath}`;
    }

    return `${BASE_URL_WITH_SLASH}${normalizedPath}`;
};